import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { MenuSubLink, MenuSubLinkExternal, MenuLinkList, MenuSubListItem } from './menuSubLinks.styles';
import { getField, getFieldIn } from '../../../../utils/cmsData';

export class MenuSubLinks extends PureComponent {
  static propTypes = {
    url: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    title: PropTypes.string,
    list: PropTypes.object,
    isFeatured: PropTypes.bool,
  };

  registerMenuLinkClick = () => {
    dataLayer.push({
      event: 'Click',
      elementType: 'Sub Menu Link',
      element: this.props.url,
    });
  };

  render() {
    const { list } = this.props;

    return (
      <MenuLinkList>
        {list
          .toArray()
          .slice(1)
          .map(item => {
            const url = getFieldIn(['url', 'url'], item);
            const Link = url && url.includes('http') ? MenuSubLinkExternal : MenuSubLink;
            const to = url && url.includes('http') ? { href: url } : { to: url };
            return (
              <MenuSubListItem key={url}>
                <Link {...to}>
                  {getField('title', item)}
                </Link>
              </MenuSubListItem>
            );
          })}
      </MenuLinkList>
    );
  }
}
